// @ts-nocheck
/* eslint-disable */
import { M3D_TEXTURE } from './texture-mapping';
import { CONFIG } from "~/config";
import Melown3dMarker from "~/melown3d/marker";
import Melown3dLayer from "~/melown3d/layer";
import Melown3dLayerDistanceMeter from "~/melown3d/layer-distance-meter";
import { _ } from "~/i18n";
import { getIcon } from "~/util/providers/poiagg";

export default class Left3dVisualiser {
	constructor(m3d) {
		this._m3d = m3d;
		 // scene itemId = smap object
		this._mapping = {};

		this._layers = [];
		this._controls = [];
	}

	/**
	 * Vola se pri deaktivaci provideru. Odstraneni vsech 3d dat.
	 */
	clear() {
		for (let id in this._mapping) {
			let item = this._mapping[id];
			item.m3d.destroy();
		}

		this._mapping = {};
		this._layers = [];
		this._controls = [];
	}

	/**
	 * Pridani vrstvy.
	 *
	 * @param {SceneLayer} layer Vrstva
	 * @param {Boolean} [before = false] Pripnout uplne nahoru?
	 */
	addLayer(layer, before) {
		let name = layer.featureInfo.name;
		let createData = layer.getCreateData();

		// fix - aby nesly videt navstivena mista
		if (createData.id == "visit-layer") return;

		if (name == "SceneLayerFree") {
			this._m3d.getPresenter()?.addFreeLayer(createData.name, createData.lines, createData.style);
		}
		else if (name == "SceneLayerMapyLookup") {
			layer.getCreateData().layers.forEach(multiLayer => {
				this._addLayer(multiLayer, before);
			});
		}
		else {
			this._addLayer(layer, before);
		}
	}

	/**
	 * Odebrani vrstvy.
	 *
	 * @param {SceneLayer} layer Vrstva
	 */
	removeLayer(layer) {
		let name = layer.featureInfo.name;
		let createData = layer.getCreateData();

		if (name == "SceneLayerFree") {
			this._m3d.getPresenter()?.removeFreeLayer(createData.name);
		}
		else if (name == "SceneLayerMapyLookup") {
			createData.layers.forEach(multiLayer => {
				this._removeLayer(multiLayer);
			});
		}
		else {
			this._removeLayer(layer);
		}
	}

	/**
	 * Vytvoreni markeru.
	 *
	 * @param  {SceneMarker} marker
	 */
	createMarker(marker) {
		// jiz existuje
		if (this._getMappingItem(marker)) return;

		let fi = marker.featureInfo;
		let data = marker.getCreateData();
		let icon = "";
		let poiData = null;
		let alwaysVisible = false;

		if (data.m3dData.onlyMap) return;

		switch (fi.name) {
			case "SceneMarkerPOI":
				if (data.fromData) {
					icon = this._getIcon(data.fromData);
					poiData = data.fromData;
				}
				break;

			case "SceneMarkerWindy":
				if (data.fromPOI) {
					icon = this._getIcon(data.fromPOI);
					poiData = data.fromPOI;
				}
				break;

			case "SceneMarkerMapyWindy":
				if (data.fromData) {
					icon = this._getIcon(data.fromData);
					poiData = data.fromData;
				}
				else if (data.fromPOI) {
					icon = this._getIcon(data.fromPOI);
					poiData = data.fromPOI;
				}
				else if (data.options.icon) {
					icon = data.options.icon;
				}
				break;

			case "SceneMarkerMapyWindyDetail":
				if (data.fromPOI) {
					let opts = data.fromPOI.opts ? data.fromPOI.opts : { icon: "" };
					icon = opts.icon || this._getIcon(data.fromPOI.poi);
					poiData = data.fromPOI.poi;
				}

				alwaysVisible = true;
				break;

			case "SceneMarkerMapyWindySearch":
				if (data.fromPOI) {
					icon = this._getIcon(data.fromPOI.poi);
					poiData = data.fromPOI.poi;

					if (data.fromPOI.opts && data.fromPOI.opts.alwaysVisible) {
						alwaysVisible = true;
					}
				}
				break;

			case "SceneMarkerMapyWindyPlace":
				icon = data.options.icon;
				break;

			case "SceneMarkerFotoPOI":
				icon = Mapy.CDN.setSize(data.fromData.url, Mapy.CDN.SIZE_40_40);

				if (data.fromData) {
					poiData = data.fromData;
				}
				break;

			case "SceneMarkerFavorite":
				poiData = {
					m3dType: "favorite",
					m3dData: data.m3dData,
					...data.m3dData.favData,
				};
				break;
		}

		// souradnice
		let x = 0;
		let y = 0;

		if (data.coords) {
			x = data.coords.x;
			y = data.coords.y;
		}

		let markerConfig = this._getMarkerConfig(data.m3dData, icon);

		// vytvorime
		let m3dMarker = new Melown3dMarker(x, y, markerConfig.opts, markerConfig.texture, markerConfig.lineStyle);
		this._saveEntity(marker, m3dMarker);

		// viditelnost
		m3dMarker.setAlwaysVisible(alwaysVisible);

		// pro detail nechceme
		if ((poiData && fi.name != "SceneMarkerMapyWindyDetail") && !CONFIG.inFrame) {
			m3dMarker.setPOI(poiData);
			m3dMarker.bindCard();
		}

		// klik
		if (typeof data.m3dData.click === "function") {
			// bind clicku na marker ve 3d
			m3dMarker.onClick(() => {
				data.m3dData.click();
			});
		}
		else if (!markerConfig.removePointerCursor) {
			// signal o kliku - def. stav, pokud nechci sam zachytavat click; napr. pro poie
			m3dMarker.onClick(() => {
				this._m3d.getScene().makeEvent(fi.name == "SceneMarker" ? "marker-click" : "marker-poi-click", {}, marker);
			});
		}

		// enter, leave nad marker
		if (!CONFIG.inFrame) {
			if (typeof data.m3dData.enter === "function") {
				m3dMarker.onMouseEnter(() => {
					data.m3dData.enter();
				});
			}

			if (typeof data.m3dData.leave === "function") {
				m3dMarker.onMouseLeave(() => {
					data.m3dData.leave();
				});
			}
		}

		if ("active" in data) {
			this.markerWMSetActive(marker, data.active);
		}

		if ("focus" in data) {
			this.markerWMSetFocus(marker, data.focus);
		}
	}

	/**
	 * Vytvoreni vrstvy.
	 *
	 * @param  {SceneLayer} layer
	 */
	createLayer(layer) {
		// jiz existuje
		if (this._getMappingItem(layer)) return;

		let fi = layer.featureInfo;
		let data = layer.getCreateData();
		let m3dLayer = null;

		switch (fi.name) {
			case "SceneLayerMapyLookup":
				break;

			case "SceneLayerMasakovac":
				m3dLayer = new Melown3dLayer();
				this._saveEntity(layer, m3dLayer);
				m3dLayer.setReposition(null);

				// pridame markery
				this.layerMarkerAddMarkers(layer, layer.getMarkers(["detail", "search"], true));
				break;

			case "SceneLayerMarker":
				m3dLayer = new Melown3dLayer();
				this._saveEntity(layer, m3dLayer);
				m3dLayer.setReposition(null);

				// pridame markery
				this.layerMarkerAddMarkers(layer, layer.getMarkers());
				break;

			case "SceneLayerDistanceMeter":
				m3dLayer = new Melown3dLayerDistanceMeter(data.points, data.linePoints, data.style);
				this._saveEntity(layer, m3dLayer);
				break;

			default:
				return;
		}

		if (data.appended && data.sceneOwner == this._m3d.getScene()) {
			this.addLayer(layer, data.before);
		}

		if (data.active) {
			this.layerEnable(layer);
		}
	}

	/**
	 * Povoleni vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerEnable(layer) {
		let smapLayer = this._getM3dItem(layer);

		if (smapLayer) {
			smapLayer.enable();
		}
	}

	/**
	 * Zakazani vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerDisable(layer) {
		let smapLayer = this._getM3dItem(layer);

		if (smapLayer) {
			smapLayer.disable();
		}
	}

	/**
	 * Smazani vsech entit vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerRemoveAll(layer) {
		let m3dLayer = this._getM3dItem(layer);

		if (m3dLayer) {
			m3dLayer.removeAll();
		}
	}

	/**
	 * Prekresleni vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Boolean} [full] Plne prekresleni?
	 */
	layerRedraw(layer, full) {
		let m3dLayer = this._getM3dItem(layer);

		if (m3dLayer) {
			m3dLayer.redraw();
		}
	}

	/**
	 * Pridani markeru do vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	layerMarkerAddMarkers(layer, markers, noRedraw) {
		let m3dLayer = this._getM3dItem(layer);
		let m3dMarkers = [];
		markers.forEach(marker => {
			let m3dMarker = this._getM3dItem(marker);

			if (m3dMarker) {
				m3dMarkers.push(m3dMarker);
			}
		});

		if (m3dLayer && m3dMarkers.length) {
			m3dLayer.addMarker(m3dMarkers, noRedraw);
		}
	}

	/**
	 * Odebrani markeru z vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	layerMarkerRemoveMarkers(layer, markers, noRedraw) {
		let m3dLayer = this._getM3dItem(layer);
		let m3dMarkers = [];
		markers.forEach(marker => {
			let m3dMarker = this._getM3dItem(marker);

			if (m3dMarker) {
				m3dMarkers.push(m3dMarker);
			}
		});

		if (m3dLayer) {
			m3dLayer.removeMarker(m3dMarkers, noRedraw);
		}
	}

	/**
	 * zmena na  makerech
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	layerMasakovacChangeMarkers(layer, markers, noRedraw) {
		let m3dLayer = this._getM3dItem(layer);
		let m3dMarkers = [];

		if (m3dLayer) {
			m3dLayer.removeAll();
			markers.forEach(marker => {
				let m3dMarker = this._getM3dItem(marker);

				if (m3dMarker) {
					m3dMarkers.push(m3dMarker);
				}
			});
			m3dLayer.addMarker(m3dMarkers, noRedraw);
		}
	}

	/**
	 * Vrstva Masakovac - Nastavi vsem POIum stav. Jestli to nejak lepe pojmenovat?
	 * Pouzite u poiu pro pruhlednost.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Boolean} state Novy stav
	 */
	layerMasakovacAllPOIState(layer, state) {
		let m3dLayer = this._getM3dItem(layer);

		if (m3dLayer) {
			m3dLayer.allPOIState(state);
		}
	}

	/**
	 * Uprava dat - zpusobi prekresleni.
	 *
	 * @param {Array} points Body rucniho mereni WGS84 [x,y]
	 * @param {Array} linePoints Body rucniho mereni pro vykresleni car WGS84 [x,y,z]
	 * @param {Object} style Vizaulni nastaveni vrstvy
	 */
	layerDistanceMeterUpdate(layer, points, linePoints, style) {
		let m3dLayer = this._getM3dItem(layer);

		if (m3dLayer) {
			m3dLayer.update(points, linePoints, style);
		}
	}

	/**
	 * Nastaveni souradnic u znacky.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {SceneCoords} coords Nove souradnice
	 */
	markerSetCoords(marker, coords) {
		let m3dMarker = this._getM3dItem(marker);

		if (m3dMarker) {
			let wgs84 = coords.toWGS84();
			m3dMarker.setCoords(wgs84[0], wgs84[1]);
		}
	}

	/**
	 * Nastaví Windy markeru stav.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Boolean} state Novy stav
	 */
	markerWMSetActive(marker, state) {
		let m3dMarker = this._getM3dItem(marker);

		if (m3dMarker) {
			m3dMarker.setActive(state);
			m3dMarker.redraw();
		}
	}

	/**
	 * Nastaví Windy markeru focus.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Boolean} state Novy stav
	 */
	markerWMSetFocus(marker, state) {
		let m3dMarker = this._getM3dItem(marker);

		if (m3dMarker) {
			m3dMarker.setFocus(state);
			m3dMarker.redraw();
		}
	}

	/**
	 * Udalost z feature - ziskani DOM containeru, synchronni verze.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 */
	featureGetContainerSync(sceneItem) {
		return Mapy.Util.node("div");
	}

	/**
	 * Udalost z feature - ziskani DOM containeru, synchronni verze.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 */
	featureGetShadowContainerSync(sceneItem) {
		return Mapy.Util.node("div");
	}

	/**
	 * Update 3d dat.
	 *
	 * @param  {SceneFeature} sceneItem Entita nad scenou
	 * @param   {Object}  m3dData Nova data
	 */
	featureUpdateM3dData(sceneItem, newM3dData, oldM3dData) {
		let type = newM3dData.type || "";

		if (type == "userMarks") {
			let m3dMarker = this._getM3dItem(sceneItem);

			if (m3dMarker) {
				let markerConfig = this._getMarkerConfig(newM3dData, newM3dData.icon || oldM3dData.icon);
				m3dMarker.update(markerConfig.opts, markerConfig.texture, markerConfig.lineStyle);
			}
		}
	}

	/**
	 * Ziskani objektu ve 3d, ktery se reprezentuje entitou nad scenou.
	 *
	 * @param  {SceneFeature} sceneItem Entita nad scenou
	 * @return {Melown3d Item}
	 */
	_getM3dItem(sceneItem) {
		let mapItem = this._getMappingItem(sceneItem);

		return (mapItem ? mapItem.m3d : null);
	}

	/**
	 * Ziskani mapovaci objektu.
	 *
	 * @param  {SceneFeature} sceneItem Objekt ze sceny
	 * @return {Object}
	 */
	_getMappingItem(sceneItem) {
		return (sceneItem.itemId in this._mapping ? this._mapping[sceneItem.itemId] : null);
	}

	/**
	 * Ulozeni melown3d entity, ktere je reprezentovana entitou nad scenou.
	 *
	 * @param  {SceneFeature} sceneItem Objekt ze sceny
	 * @param  {Melown3d Item} m3dItem Objekt ve 3d
	 */
	_saveEntity(sceneItem, m3dItem) {
		this._mapping[sceneItem.itemId] = {
			m3d: m3dItem,
			scene: sceneItem
		};
	}

	/**
	 * Odstraneni melown3d entity, ktera je reprezentovana entitou nad scenou.
	 *
	 * @param  {SceneFeature} sceneItem Objekt nad scenou
	 */
	_deleteItem(sceneItem) {
		let mappingItem = this._getMappingItem(sceneItem);

		if (mappingItem) {
			if (typeof mappingItem.m3d.destroy === "function") {
				mappingItem.m3d.destroy();
			}
		}

		delete this._mapping[sceneItem.itemId];
	}

	/**
	 * Pridani vrstvy.
	 *
	 * @param {SceneLayer} layer Vrstva
	 * @param {Boolean} [before = false] Pripnout uplne nahoru?
	 * @private
	 */
	_addLayer(layer, before) {
		let m3dLayer = this._getM3dItem(layer);

		if (!m3dLayer || this._layers.indexOf(layer) != -1) return;

		this._m3d.getPresenter()?.addLayer(m3dLayer);
	}

	/**
	 * Odebrani vrstvy.
	 *
	 * @param {SceneLayer} layer Vrstva
	 * @private
	 */
	_removeLayer(layer) {
		let m3dLayer = this._getM3dItem(layer);

		if (!m3dLayer || this._layers.indexOf(layer) == -1) return;

		this._m3d.getPresenter()?.removeLayer(m3dLayer);
	}

	/**
	 * Ziskani URL ikony z POI dat.
	 *
	 * @param  {Object} poi POI data
	 * @return {String}
	 */
	_getIcon(poi) {
		if ("icon" in poi && poi.icon["1"]) {
			return poi.icon["1"];
		}
		else if (poi.favicon) {
			return poi.favicon;
		}
		else {
			return getIcon(poi.typeId || poi.poiTypeId);
		}
	}

	/**
	 * Ziskani konfigurace pro 3d markery.
	 *
	 * @param   {Object}  m3dData Data
	 * @param   {String} [icon] Dostupna ikona?
	 * @return  {Object}
	 */
	_getMarkerConfig(m3dData, icon = "") {
		let opts = {};
		let texture = {
			src: icon,
			active: icon ? M3D_TEXTURE.mapping.middleMarkerActive : M3D_TEXTURE.mapping.middleMarkerUniversalActive,
			nonActive: icon ? M3D_TEXTURE.mapping.middleMarker : M3D_TEXTURE.mapping.middleMarkerUniversal
		};
		let lineStyle = {};
		let type = m3dData.type || "";

		// offset pro markery pro spravny z index
		opts.depthOffset = [-0.2, 0, 0];

		switch (type) {
			case "userMarks":
				opts.removePointerCursor = true;
				texture.src = "";
				texture.text = `${m3dData.index}`;
				texture.font = "12px Arial";
				texture.active =  M3D_TEXTURE.mapping.middleMarkerActive;
				texture.nonActive =  M3D_TEXTURE.mapping.middleMarker;
				break;

			case "route":
				opts.removePointerCursor = true;
				texture.src = "";
				texture.active = M3D_TEXTURE.mapping.bigMarkerActive;
				texture.nonActive = M3D_TEXTURE.mapping.bigMarker;

				switch (m3dData.value) {
					case "start":
						texture.text = _("route.form.start");
						break;

					case "end":
						texture.text = _("route.form.end");
						break;

					default:
						texture.active = M3D_TEXTURE.mapping.middleMarkerUniversalActive;
						texture.nonActive = M3D_TEXTURE.mapping.middleMarkerUniversal;
				}
				break;

			case "detail":
				opts.removePointerCursor = true;

				if (icon) {
					texture.active = M3D_TEXTURE.mapping.bigMarkerActive;
					texture.nonActive = M3D_TEXTURE.mapping.bigMarker;
				}
				break;

			case "places":
				if (m3dData.svg) {
					let mapping = {
						car: "carSvg",
						"star-line": "starSvg",
						"custom-points": "userMarksSvg",
						"custom-distance": "distanceMeterSvg",
						bike: "bikeSvg",
						run: "runSvg",
						walk: "walkSvg",
						home: "homeSvg",
						boat: "boatSvg",
						"ski-cross-country": "skiCrossCountrySvg",
						ski: "skiSvg",
						work: "workSvg"
					};

					if (m3dData.svg in mapping) {
						texture.active = M3D_TEXTURE.mapping.middleMarkerActive;
						texture.nonActive = M3D_TEXTURE.mapping.middleMarker;
						texture.src = "";
						texture.texture = mapping[m3dData.svg];
					}
					else {
						// eslint-disable-next-line no-console
						console.log(`Missing ${m3dData.svg}`);
					}
				}
				break;

			case "foto":
				texture.active = M3D_TEXTURE.mapping.photo;
				texture.nonActive = M3D_TEXTURE.mapping.photo;
				lineStyle.activeColor = [255, 255, 255, 255];
				lineStyle.color = [255, 255, 255, 255];
				break;

			case "lineChart":
				opts.depthOffset = [opts.depthOffset[0] - 0.1, 0, 0];
				texture.active = M3D_TEXTURE.mapping.littleMarkerUniversalActive;
				texture.nonActive = M3D_TEXTURE.mapping.littleMarkerUniversal;
				break;

			case "placesRoute":
				texture.active = M3D_TEXTURE.mapping.littleMarkerUniversalActive;
				texture.nonActive = M3D_TEXTURE.mapping.littleMarkerUniversal;
				break;

			case "favorite":
				texture.src = "/img/m3d/favorite.png";
				texture.active = M3D_TEXTURE.mapping.favorite;
				texture.nonActive = M3D_TEXTURE.mapping.favorite;
				lineStyle.activeColor = null;
				lineStyle.color = null;
				break;
		}

		return {
			opts,
			texture,
			lineStyle
		};
	}
}
